/*
 * Copyright 2025 Intuition Robotics ltd
 */
import __asset_0 from "@res/icons/icon_arrowhead_dropdown_dark.svg";
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {COLORS} from "@res/colors";
import {ICONS} from "@res/icons";
import {CheckboxOptions} from "../pages/widget/Checkbox";

type Props = {
	filterList: CheckboxOptions[],
	filterType: string,
	open: boolean,
	inline?: boolean,
	filterFiller?:string
}

export class Filter
	extends BaseComponent<Props, {}> {

	constructor(props: Props) {
		super(props);
	}

	renderFilter = () => {
		let filterFiller: string;
		const filter = this.props.filterList.filter(_filter => _filter.type === this.props.filterType);
		switch (filter.length) {
			case 0:
				if(this.props.filterFiller)
					filterFiller = this.props.filterFiller
				else
					filterFiller = "All";
				break;
			case 1:
				filterFiller = filter[0].name;
				break;
			default:
				filterFiller = "Multi";
		}
		return <div style={{margin: "16px", color: COLORS.neutral_text_dark_2}}>
			{!this.props.inline && <div style={{paddingBottom: '10px', fontSize: 12, paddingRight: '5px'}}>
				{`${this.props.filterType}`}
			</div>}
			<div style={{
				border: "solid",
				borderWidth: "1px",
				color: COLORS.neutral_text_dark,
				backgroundColor: this.props.open ? COLORS.very_light_blue : `rgb(244, 247, 247)`,
				borderColor: this.props.open ? COLORS.primary_blue : COLORS.grays_2,
				display: "flex",
				height: "25px"
			}}>
				<div style={{
					width: "130px",
					marginLeft: "5px",
					marginTop: "3px",
					overflow: "hidden"
				}}>{`${filterFiller}`}</div>
				<div style={{width: 16, height: 16, borderRadius: "100%", backgroundColor: COLORS.very_light_blue, marginTop: "3px", marginRight: "5px"}}>
					{this.props.open ? <img src={__asset_0} height={16} width={16} style={{display: "block", margin: "auto"}}/>
						: ICONS.icon_arrow_down(COLORS.primary_dark_blue, 16)}
				</div>
			</div>
		</div>;
	};

	render() {
		return this.renderFilter();
	}
}
